import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import $ from "jquery";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "mobx-react";
import store from "./stores/index";

window.$ = window.jQuery = $;

ReactDOM.render(
  <Provider {...store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js